import { CommonModule } from "@angular/common";
import {
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  inject,
  Injectable, signal, SimpleChanges, OnChanges
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import {RestClient, Rights, User} from '../Api/DcoApi/Client/RestClient';
import {Phonnumberextractor} from '../Services/Phonnumberextractor';


@Component({
  selector: 'PhoneCall',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './PhoneCall.html',
  styleUrl: './PhoneCall.css'
})

export class PhoneCall implements OnChanges {
  @Input() number: string = '';
  ApiClient: RestClient = new RestClient();
  Phonnumberextractor: Phonnumberextractor = new Phonnumberextractor();
  CanMakecalls = () => User.HasRight(Rights.TeamsView) && this.phonenumber() != ''
  phonenumber = signal<string>("")


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['number']) {
      this.phonenumber.set(this.Phonnumberextractor.Export(this.number))
    }
  }
  Call() {
    if(this.CanMakecalls())
    {
      this.ApiClient.Get<any>(`/Backend/Api/V2/Teams?phonenumber=%2B${this.phonenumber()}`)
    }
  }
}
